import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type ConfirmButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
};

const ConfirmButton = ({
    label = "Confirm",
    loadingText = "Confirming...",
    buttonType = "submit",
    ...props
}: ConfirmButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="confirm"
            testId="confirm-button"
            buttonType={buttonType}
            {...props}
        />
    );
};

export default ConfirmButton;
